import React from 'react';
import { useNavigate, useLocation } from 'react-router';
import { ListItemIcon, ListItemText, Collapse, List, Box } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { StyledSidebarItem, StyledListItemIcon } from './Sidebar.styles';
import SidebarSubItem from './SidebarSubItem';

const isExternalLink = (url) => {
	return url && (url.startsWith('http://') || url.startsWith('https://'));
};

const SidebarItem = ({ item, openItemId, setOpenItemId, onMobileItemClick }) => {
	const navigate = useNavigate();
	const location = useLocation();
	const isActive = location.pathname === item.path;
	const isOpen = openItemId === item.title;
	const isExternal = isExternalLink(item.path);

	const handleClick = (event) => {
		event.preventDefault();
		if (item.subItems) {
			setOpenItemId(isOpen ? null : item.title);
		} else {
			if (isExternal) {
				window.open(item.path, '_blank', 'noopener,noreferrer');
			} else {
				navigate(item.path);
			}
			onMobileItemClick();
		}
	};

	const itemContent = (
		<>
			<StyledListItemIcon>
				{item.icon && (
					<Box
						component="img"
						alt={item.title}
						src={item.icon}
						sx={{
							height: '24px',
							width: '24px'
						}}
					/>
				)}
			</StyledListItemIcon>
			<ListItemText primary={item.title} />
			{item.subItems && (isOpen ? <ExpandLess /> : <ExpandMore />)}
		</>
	);

	return (
		<>
			<StyledSidebarItem
				onClick={handleClick}
				isActive={isActive}
				component={isExternal ? 'a' : 'div'}
				href={isExternal ? item.path : undefined}
				target={isExternal ? '_blank' : undefined}
				rel={isExternal ? 'noopener noreferrer' : undefined}
			>
				{itemContent}
			</StyledSidebarItem>
			{item.subItems && (
				<Collapse in={isOpen} timeout="auto" unmountOnExit>
					<List component="div">
						{item.subItems.map((subItem, index) => (
							<SidebarSubItem key={index} item={subItem} onMobileItemClick={onMobileItemClick} />
						))}
					</List>
				</Collapse>
			)}
		</>
	);
};

export default SidebarItem;
